var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CRow',[_c('CCol',{attrs:{"md":"12"}},[_c('a-table',{staticClass:"mt-3",attrs:{"row-key":"codEmpresa","columns":_vm.columnasEmpresas,"data-source":_vm.empresasFiltradas,"pagination":_vm.paginacionEmpresas,"scroll":{ y: 600 },"locale":_vm.localeEmpresas,"size":"small"},on:{"expand":_vm.expandirEmpresa,"change":_vm.cambioPaginaEmpresas}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }